<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true"
    [styleClass]="'w-[95vw] h-[65vh] md:w-[500px] md:h-[470px]'" (onHide)="onClose()">

    <div class=" bg-gray-20 border-gray-300">

        <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-4  sm:px-4">
            <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">Absentee Bidding</h2>
            <p class="text-sm mt-2  font-mulish font-semibold  text-white">Can't attend the Live Event? Absentee Bidding lets you participate by submitting your maximum bid in advance. During the Live Event, bids are placed on your behalf only as needed, up to the maximum amount you authorize.</p>
        </div>
        <div class="flex flex-col md:flex-row w-full gap-4  ">
            <div class=" flex-1 rounded-lg bg-white shadow-md  mt-4 ">
           
                    <span class="text-center font-semibold ml-2">How it works?</span>
         
                <div class="flex flex-col  space-y-2 px-2 mt-2 mb-3">
                    <ul class="list-disc pl-5">
                        <li>Enter your maximum bid before the Live Event.</li>
                        <li>We bid on your behalf during live bidding.</li>
                        <li>Your bid increases only when needed.</li>
                        <li>We never exceed your maximum amount.</li>
                        <li>If your bid is the highest at the end of the auction, you win.</li>

                    </ul>
                </div>
            </div> 
        </div>

       <div class="">
        <button pButton class=" h-[40px] !bg-custom-blue !border-0 !shadow-none rounded-m w-full relative flex items-center justify-center mt-8 "
            (click)="onClose()" [rounded]="true">
            <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>
            <span class="font-semibold text-white text-center w-full text-base">
                Done
            </span>
        </button>
      </div>
    </div>

</p-dialog>